// extracted by mini-css-extract-plugin
export default {"link":"ProjectSubmissionPage_link__f26BV","files":"ProjectSubmissionPage_files__69xC3","file":"ProjectSubmissionPage_file__U5lhI"};